import Backbone from 'backbone';
import NavigationHistory from '../../common/views/NavigationHistory';
import $ from 'jquery';

export default Backbone.View.extend({
  navigationHistory: null,

  selectors: {
    navigationHistory: '.js-navigationHistory',
  },

  events: {},

  initialize: function (options) {
    this.setElement(options.el);

    const $history = $(this.selectors.navigationHistory);

    if ($history.length) {
      this.navigationHistory = new NavigationHistory({ $el: $(this.selectors.navigationHistory) });
    }
  },
});
